var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
var actionHandlers = (_a = {},
    _a[initialize.toString()] = function (state, action) { return (__assign(__assign({}, state), { isLoading: true, isError: false })); },
    _a[requestFailure.toString()] = function (state, action) { return (__assign(__assign({}, state), { isLoading: false, isError: true })); },
    _a[requestSuccess.toString()] = function (state, _a) {
        var payload = _a.payload;
        return __assign(__assign({}, state), { isLoading: false, data: payload.data });
    },
    _a);
var reducers = (_b = {},
    // cast "as string" because of TS
    _b[reduxKey] = function (state, action) {
        var _a;
        if (state === void 0) { state = {}; }
        var type = action.type, payload = action.payload;
        if (!actionHandlers[type]) {
            return state;
        }
        var stateKey = payload.deviationId;
        return __assign(__assign({}, state), (_a = {}, _a[stateKey] = actionHandlers[type](state[stateKey], action), _a));
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map